import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconVideoTrim: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconVideoTrim"><Path d="M15.25 2.75V4.75M15.25 4.75V19.25M15.25 4.75H5.75C4.09315 4.75 2.75 6.09315 2.75 7.75V16.25C2.75 17.9069 4.09315 19.25 5.75 19.25H15.25M15.25 19.25V21.25M18.75 19.25C20.1307 19.25 21.25 18.1307 21.25 16.75V7.25C21.25 5.86929 20.1307 4.75 18.75 4.75M8.25 12H9M8.25 12V11.75M8.25 12V12.25M7.5 9.5V14.5L10.75 12L7.5 9.5Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></CentralIconBase>;
});

export default IconVideoTrim;
